import {
  Body,
  EmptyState,
  ErrorMessage,
  LoadingState,
  PageHeader,
  VInput,
} from '@vrzl/ui';
import { Search, Users } from 'lucide-react';
import { useMemo, useState } from 'react';

import { useAdminPerspectives, useAdminUsers } from '../api/queries';

import { AddUserForm } from './addUserForm';
import { UserCard } from './userCard';

export function AdminUsers() {
  const usersQuery = useAdminUsers();
  const perspectivesQuery = useAdminPerspectives();

  const [search, setSearch] = useState('');

  const allUsers = useMemo(() => usersQuery.data?.items ?? [], [usersQuery.data]);
  const perspectives = perspectivesQuery.data?.items ?? [];

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return allUsers;
    return allUsers.filter((user) => user.email.toLowerCase().includes(q));
  }, [allUsers, search]);

  return (
    <div>
      <PageHeader
        title="Administratie"
        description="Beheer gebruikerskoppelingen voor deze omgeving"
      />

      <AddUserForm />

      {usersQuery.isPending && <LoadingState />}
      {usersQuery.error && <ErrorMessage error={usersQuery.error} />}

      {usersQuery.data && (
        <>
          <div className="mb-4 flex items-center justify-between gap-4">
            <Body tone="muted">{allUsers.length} gebruikers</Body>
            <div className="relative w-full max-w-xs">
              <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
              <VInput
                type="search"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder="Zoek op e-mail"
                className="w-full pl-9"
              />
            </div>
          </div>

          {allUsers.length === 0 ? (
            <EmptyState icon={Users} title="Nog geen gebruikers" />
          ) : (
            <div className="flex flex-col gap-3">
              {filtered.map((user) => (
                <UserCard
                  key={user.userId}
                  user={user}
                  allPerspectives={perspectives}
                />
              ))}
              {filtered.length === 0 && (
                <Body tone="muted">{`Geen gebruikers gevonden voor "${search}".`}</Body>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
